import React, { Component } from 'react';
import Datas from '../../../data/team/team-slider2.json';
import { Container, Row, Col } from 'react-bootstrap';
import Swiper from 'react-id-swiper';
import { Styles } from "../../styles/teamSlider2.js";
import { withTranslation } from 'react-i18next';

class TeamSlider2 extends Component {
    state = {
        showModal: false,  // To control the modal visibility
        selectedTeam: {},  // To store the selected team data (personName, fullText)
    };

    // Function to handle opening the modal
    openModal = (personName, fullText) => {
        this.setState({
            showModal: true,
            selectedTeam: { personName, fullText }
        });
    };

    // Function to handle closing the modal
    closeModal = () => {
        this.setState({
            showModal: false,
            selectedTeam: {}
        });
    };

    render() {
        const { t, i18n } = this.props;
        const translateOr = (key, fallback) => {
            const translated = t(key);
            return translated === key ? fallback : translated;
        };
        const settings = {
            slidesPerView: 3,
            loop: true,
            speed: 1000,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            spaceBetween: 30,
            watchSlidesVisibility: true,
            pagination: {
                el: '.slider-dot.text-center',
                clickable: true
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                576: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3
                },
                992: {
                    slidesPerView: 3
                }
            }
        };

        return (
            <Styles>
                {/* Team Slider */}
                <section className="team-member-area">
                    <Container>
                        <Row>
                            <Col md="12">
                                <div className="sec-title text-center">
                                    <h4>{translateOr('home.why.title', Datas.secTitle)}</h4>
                                </div>
                            </Col>
                            <Col md="12" className="team-slider">
                                <Swiper key={i18n.language} {...settings}>
                                    {
                                        Datas.dataList.map((data, i) => (
                                            <div className="team-item" key={data.id}>
                                                <img src={process.env.PUBLIC_URL + `/assets/images/${data.personImage}`} alt="" className="img-fluid" />
                                                <div className="img-content text-center">
                                                    <img src={process.env.PUBLIC_URL + `/assets/images/${data.contentLogo}`} alt="" className="img-fluid_content_logo" />
                                                    <h5>{translateOr(`home.why.list.${i}.title`, data.personName)}</h5>
                                                    <p>{translateOr(`home.why.list.${i}.text`, data.fullText)}</p>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </Swiper>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Styles>
        );
    }
}

export default withTranslation()(TeamSlider2);